exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accordion-button.collapsed[data-v-49074afc]{background:#babdc8}.accordion-button[data-v-49074afc]:not(.collapsed){color:#4d63cf;background-color:#9699a6}", ""]);

// exports
